import { RouteConfig } from '../types/RouteConfig';
import { accountRoutes } from './account/routes';
import { biopakRoutes } from './biopak/routes';
import { bookerRoutes } from './booker/routes';
import { calorRoutes } from './calor/routes';
import { advertsRoutes } from './adverts/routes';
import { documentsRoutes } from './documents/routes';
import { errorRoutes } from './error/routes';
import {
    digitalSmsRoute, wordpressContactUsRoute, wordpressMemberResourcesRoute
} from './external-routes';
import { financeRoutes } from './finance/routes';
import { iconsRoute } from './icons/route';
import { landingPageRedirectionRoute } from './landing-page-redirection/route';
import { dashboardPageRoute } from './member-home/route';
import { myAccountRoutes } from './my-account/routes';
import { nisbetsRoutes } from './nisbets/routes';
import { rewardsRoutes } from './rewards/routes';
import { starterPageRoute } from './starter-page/route';
import { testPageRoute } from './test-page/route';
import { unitPremisesRoute } from './unit-premises/route';
import { trainingRoutes } from './training/routes';
import { traineeRoute } from './training/trainee/route';
import { walletPageRoute } from './wallet/home/route';
import { maintenanceRoute } from '../pages/maintenance/route';
import { helpVideosPageRoute } from './help-videos/route';
import { planToRenew } from './my-account/plan-to-renew/route';
import { noPlanToRenew } from './my-account/no-plan-to-renew/route';
import { defaultDocumentsRoute } from './documents/default-documents/route';
import { useHttpExamplesPageRoute } from './use-http-examples/route';
import { checkboxExamplesPageRoute } from './checkbox-examples/route';
import { membershipHubRoute } from './membership-hub/route';
import { sendDocumentsRoutes } from './send-documents/routes';
import { workOppsRoutes } from './work-opps/routes';

export const homeRoute = landingPageRedirectionRoute;

const schemeManagementRoutes = [
    bookerRoutes,
    biopakRoutes,
    calorRoutes,
    nisbetsRoutes,
    defaultDocumentsRoute
]

const memberRoutes = [
    dashboardPageRoute,
    digitalSmsRoute,
    myAccountRoutes,
    documentsRoutes,  
    unitPremisesRoute,
    trainingRoutes,
    sendDocumentsRoutes,
    traineeRoute,
    workOppsRoutes,
    
    rewardsRoutes,
    walletPageRoute,

    wordpressMemberResourcesRoute,
    advertsRoutes,
    helpVideosPageRoute,
    wordpressContactUsRoute,
    planToRenew,
    noPlanToRenew

]

const developerRoutes = [
    maintenanceRoute,
    testPageRoute,
    iconsRoute,
    useHttpExamplesPageRoute,
    checkboxExamplesPageRoute,
    membershipHubRoute,
]

export const routes: RouteConfig[] = [
    homeRoute,
    starterPageRoute,
    accountRoutes,
    ...memberRoutes,
    ...schemeManagementRoutes,
    financeRoutes,
    ...developerRoutes,
    errorRoutes,
]